exports = module.exports = require("../../node_modules/_css-loader@0.27.3@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".doctor2 .el-breadcrumb[data-v-0c1ee10a]{margin:0 30px 15px 0}.doctor2 h3[data-v-0c1ee10a]:after{content:\" \";width:14px;height:6px;background-color:#67c23a;display:block;margin:12px 0 20px}.doctor2 img[data-v-0c1ee10a]{border-radius:5px}.doctor2 p[data-v-0c1ee10a]{font-size:13px;color:#231f20;padding:5px 0}.doctor2 .jb-list[data-v-0c1ee10a]{margin-bottom:15px}.doctor2 .el-form-item[data-v-0c1ee10a]{margin-bottom:9px}.doctor2 .el-button--primary[data-v-0c1ee10a]{margin-top:20px}.doctor2 .c-t[data-v-0c1ee10a]{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;justify-content:space-between;margin-top:15px}.doctor2 .el-alert[data-v-0c1ee10a]{margin-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.27.3@css-loader?minimize!./~/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c1ee10a","scoped":true,"hasInlineConfig":false}!./~/_sass-loader@7.1.0@sass-loader/lib/loader.js!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/doctor2.vue
// module id = 163
// module chunks = 1